import { useEffect, useState } from 'react';
import QueryString from 'query-string';

const useQuery = (queryString) => {
  const [query, setQuery] = useState({});

  useEffect(() => {
    setQuery(QueryString.parse(queryString));
  }, [queryString]);

  return query;
};

export default useQuery;
